import { InclusionContent } from "@silversea-ssc/ui-components-react"
import { InclusionCode } from "@ssc-booking/api-contracts"
import * as O from "fp-ts/Option"
import * as F from "fp-ts/function"
import * as A from "fp-ts/Array"
import * as S from "fp-ts/string"
import * as ORD from "fp-ts/Ord"
import * as EQ from "fp-ts/Eq"

export const inclusionContentByCode =
    (content: InclusionContent[]) =>
    (inclusionCode: InclusionCode): O.Option<InclusionContent> =>
        F.pipe(
            content,
            A.findFirst((c) => c.codes.includes(inclusionCode)),
        )

export const orderByInclusionInfographicTitle = F.pipe(
    S.Ord,
    ORD.contramap((i: InclusionContent) => i.infographicTitle),
)

export const eqByInclusionInfographicTitle = F.pipe(
    S.Eq,
    EQ.contramap((x: InclusionContent) => x.infographicTitle),
)
